import { render, staticRenderFns } from "./AlreadyApproved.vue?vue&type=template&id=2bbab0b6&scoped=true"
import script from "./AlreadyApproved.vue?vue&type=script&lang=js"
export * from "./AlreadyApproved.vue?vue&type=script&lang=js"
import style0 from "../apply-step.css?vue&type=style&index=0&id=2bbab0b6&prod&scoped=true&lang=css&external"
import style1 from "./AlreadyApproved.vue?vue&type=style&index=1&id=2bbab0b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbab0b6",
  null
  
)

export default component.exports